import { LOADING_EXTRAS, RECEIVED_EXTRAS, RECEIVED_EXTRAS_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/pii/${pii}/extras?token=${token}`,
  },
  fetch: createFetcher(LOADING_EXTRAS, RECEIVED_EXTRAS, RECEIVED_EXTRAS_FAILED),
};
